export default __webpack_public_path__ + "static/media/in.2ba098d4.svg";